import React from "react";
import blackLogo from "../../assets/images/blackLogo.svg";

interface SystemMessageBannerProps {
  text: string;
  onClick?: () => void;
  timestamp?: string;
}

/** Full-width gray notice used for system and deal status messages. */
export const SystemMessageBanner: React.FC<SystemMessageBannerProps> = ({
  text,
  onClick,
  timestamp,
}) => {
  const interactiveProps = onClick
    ? {
        role: "button",
        tabIndex: 0,
        onClick,
        onKeyDown: (e: React.KeyboardEvent) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        },
      }
    : {};

  return (
    <div
      {...interactiveProps}
      className={`my-4 flex min-h-9 w-full items-center justify-center gap-2 rounded-2xl bg-gray-200 px-4 py-2 font-['Plus_Jakarta_Sans'] ${
        onClick ? "cursor-pointer hover:bg-gray-300/70" : ""
      }`}
    >
      <img src={blackLogo} alt="" className="h-4 w-auto shrink-0" />
      <p className="break-words text-center text-sm leading-5 text-gray-700">
        {text}
        {timestamp && (
          <span className="ml-2 text-[10px] text-gray-500">{timestamp}</span>
        )}
      </p>
    </div>
  );
};
